import { Injectable, signal } from '@angular/core';

import { MenuItem } from '../../shared/models/side-menu.model';
import { ResponseData } from '@shared/helpers/response-data';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})

export class MenuStateService {
  #menuItems = signal<ResponseData<MenuItem[]>>({
    data: null,
    status: 'loading'
  });
  readonly menuItems$ = toObservable(this.#menuItems);

  #isMenuOpen = signal(false);
  readonly isMenuOpen$ = toObservable(this.#isMenuOpen);

  setMenuItems(value: ResponseData<MenuItem[]>): void {
    this.#menuItems.set(value);
  }

  toggleMenu(): void {
    this.#isMenuOpen.update(current => !current);
    document.body.classList.toggle('expand-side-menu');
  }

  setMenuState(isOpen: boolean): void {
    this.#isMenuOpen.set(isOpen);
  }
}
